import {useMemo} from 'react';
import {useTheme} from '@mui/material';
import type {RightPanelConfig} from 'components/scene/types';
import {FieldExtensionEnum} from 'sceneExtensions/types';
import type {
  LinkedValueSearchPageConfig,
  LinkedValueSearchSceneExtensionCore,
} from '../types';
// eslint-disable-next-line import-x/no-cycle
import {LinkedValueSearchContainer} from '../LinkedValueSearchContainer';
import {useLinkedValueSearchFieldExtension} from './useLinkedValueSearchFieldExtension';

const defaultConfig: Partial<RightPanelConfig> = {};

export const useLinkedValueSearchSceneExtensionCore = (
  config: Partial<RightPanelConfig> = defaultConfig,
  pageConfig?: LinkedValueSearchPageConfig,
) => {
  const linkedValueSearchFieldExtension = useLinkedValueSearchFieldExtension();
  const {palette} = useTheme();

  return useMemo((): LinkedValueSearchSceneExtensionCore => {
    return {
      type: FieldExtensionEnum.linkedValueSearch,
      panelConfig: {
        backgroundColour: palette.background.brown.level1,
        ...config,
      },
      renderRightPanel: () => <LinkedValueSearchContainer />,
      fieldContext: linkedValueSearchFieldExtension,
      pageConfig: pageConfig,
    };
  }, [
    config,
    linkedValueSearchFieldExtension,
    pageConfig,
    palette.background.brown.level1,
  ]);
};
